/**
 * Created by jonas on 2022-10-27.
 */
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {XW2GameMode, XwaysHoarder2} from "../XwaysHoarder2";
import {BasicSymbol, SymbolStates} from "../reels/symbols/BasicSymbol";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";
import {gsap} from "gsap";
import {LTSymbol} from "../reels/symbols/LTSymbol";
import {SimpleReelModelState, SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {ScatterSymbol} from "../reels/symbols/ScatterSymbol";
import {XWaySymbol} from "../reels/symbols/XWaySymbol";
import {XSplitSymbol} from "../reels/symbols/XSplitSymbol";


export class RestoreUtils {

    public static DEFAULT_STARTUP_REELS = [
        ['M1', 'L2', 'L1', 'L3', 'M1', 'L2'],
        ['L4', 'M4', 'M3', 'L2', 'L1', 'L4'],
        ['L3', 'M1', 'L4', 'M4', 'M2', 'M1'],
        ['M3', 'L3', 'L2', 'L4', 'L1', 'L3'],
        ['L1', 'L2', 'M1', 'L3', 'M2', 'L1']
    ]

    public static hasRestored: boolean = false;

    constructor() {
    }

    public static startupGame() {

        if (XwaysHoarder2.model.isRestore) {
            RestoreUtils.restore();
            RestoreUtils.hasRestored = true;
            XwaysHoarder2.plusFsView.init();
        } else {
            RestoreUtils.normalStartUp();
            XwaysHoarder2.plusFsView.init();
        }
    }

    public static normalStartUp() {
        const reelData = XwaysHoarder2.model.initData.reels;

        //XwaysHoarder2.transitionPlayer.playSpineIdleLoop(XW2GameMode.NORMAL);
    }

    public static restoreXWays() {
        const reelData = XwaysHoarder2.model.initData.reels;
    }


    public static restoreLootSpins(): void {
        //const model = XwaysHoarder2.model;
        //const reelData = model.initData.reels;

        //debugger;

        if ((XwaysHoarder2.model.data.mode === GameMode.NORMAL && XwaysHoarder2.model.data.nextMode === GameMode.RESPIN) || (XwaysHoarder2.model.data.mode === GameMode.RESPIN && XwaysHoarder2.model.data.nextMode === GameMode.RESPIN)) {
            const sym: LTSymbol = <LTSymbol>XwaysHoarder2.reelView.reels[0].createSymbol("LT", SimpleReelModelState.STOP, {
                reelID: 0,
                position: 0
            }, 1);
            const symData: SimpleReelModelSymbolData = {
                name: "LT",
                positionable: sym,
                reelPosition: 0,
                reelId: 0,
                symbolSize: 1
            }
            const tl: gsap.core.Timeline = gsap.timeline();
            tl.add(sym.restoreCase().timeScale(2), 0);


            if (XwaysHoarder2.model.data.nextRespinIsTheLastReSpin) {
                tl.add(sym.playLTLightSpineAnimation("LootLightLoop", false, true), ">");
                tl.add(() => {
                    sym.position.y = 0
                    sym.isSticky = false;
                    (<LTSymbol>sym).setSpinePos(false);
                    XwaysHoarder2.reelView.reels[0].model.LTarray = [];
                    (<BasicSymbol>XwaysHoarder2.reelView.reels[0].model.symbols[2].positionable).destroy();
                    XwaysHoarder2.reelView.reels[0].model.symbols.splice(2, 1, symData);
                })
                tl.add(() => {
                    sym.moveToNormalLayer();
                });
            } else {
                tl.add(() => {
                    XwaysHoarder2.reelView.reels[0].model.LTarray.push(symData);
                }, 0);
                let respinMusicName: string = XwaysHoarder2Sound.RESPIN_VOICE_N_MUSIC[0][1];
                if (XwaysHoarder2.apiPlugin.gameClientConfiguration.useCensoredSoundUS && respinMusicName.includes("3")) {
                    respinMusicName = XwaysHoarder2Sound.RESPIN_MUSIC_US;
                }
                tl.add(() => {
                    XwaysHoarder2Sound.switchMusic({name: respinMusicName}, {
                        name: respinMusicName,
                        from: 0,
                        to: 1,
                        duration: 2600
                    })
                }, 0);
            }
            tl.timeScale(100);
        }



        XwaysHoarder2.backgroundElements.setBackground(GameMode.NORMAL, XwaysHoarder2.model.data.mode, true);
        XwaysHoarder2.transitionPlayer.playSpineIdleLoop(XW2GameMode.NORMAL);
    }

    public static restoreSuperFreespins(): void {
        //debugger;
        //XwaysHoarder2.fsIndicators.setSpinValue(XwaysHoarder2.model.data.freespinsLeft);
        if (XwaysHoarder2.model.mode === "SUPER_FREESPIN") {
            XwaysHoarder2.fsIndicators.restoreIndicators();
        }
        //XwaysHoarder2.keypadPlugin.toggleVisibility(false);

        if(XwaysHoarder2.model.data.mode !== XW2GameMode.NORMAL) {
            XwaysHoarder2.backgroundElements.setBackground(GameMode.FREESPIN, XwaysHoarder2.model.data.mode, true);
            XwaysHoarder2.foregroundElements.setForeground(XW2GameMode.FREESPIN, XwaysHoarder2.model.data.mode, true);
            XwaysHoarder2.transitionPlayer.playSpineIdleLoop(XW2GameMode.FREESPIN);
            XwaysHoarder2.fsIndicators.show();
            XwaysHoarder2Sound.switchMusic({name: XwaysHoarder2Sound.SFS_MUSIC});
        }
        else {
            XwaysHoarder2.backgroundElements.setBackground(GameMode.NORMAL, XwaysHoarder2.model.data.mode, true);
            XwaysHoarder2.foregroundElements.setForeground(XW2GameMode.NORMAL, XwaysHoarder2.model.data.mode, true);
            XwaysHoarder2.transitionPlayer.playSpineIdleLoop(XW2GameMode.NORMAL);
        }

    }

    public static restoreFreespins(): void {
        //XwaysHoarder2.fsIndicators.setSpinValue(XwaysHoarder2.model.data.freespinsLeft);
        XwaysHoarder2.fsIndicators.restoreIndicators();
        //XwaysHoarder2.keypadPlugin.toggleVisibility(false);

        if(XwaysHoarder2.model.data.mode !== XW2GameMode.NORMAL) {
            XwaysHoarder2.backgroundElements.setBackground(GameMode.FREESPIN, XwaysHoarder2.model.data.mode, true);
            XwaysHoarder2.foregroundElements.setForeground(XW2GameMode.FREESPIN, XwaysHoarder2.model.data.mode, true);
            XwaysHoarder2.transitionPlayer.playSpineIdleLoop(XW2GameMode.FREESPIN);
            XwaysHoarder2.fsIndicators.show();
            XwaysHoarder2Sound.switchMusic({name: XwaysHoarder2Sound.FS_MUSIC});
        }
        else {
            XwaysHoarder2.backgroundElements.setBackground(GameMode.NORMAL, XwaysHoarder2.model.data.mode, true);
            XwaysHoarder2.foregroundElements.setForeground(XW2GameMode.NORMAL, XwaysHoarder2.model.data.mode, true);
            XwaysHoarder2.transitionPlayer.playSpineIdleLoop(XW2GameMode.NORMAL);
        }


    }

    public static restoreBingeSpins() {

        XwaysHoarder2.fsIndicators.hide();

        if (XwaysHoarder2.model.data.currentFSLevel < 4) {
            XwaysHoarder2.bonusDoors.closeGate(XW2GameMode.BINGE_SPINS);
            if (XwaysHoarder2.model.data.mode === "FREESPIN") {
                XwaysHoarder2Sound.switchMusic({name: XwaysHoarder2Sound.FS_MUSIC});
            } else if (XwaysHoarder2.model.data.mode === "SUPER_FREESPIN") {
                XwaysHoarder2Sound.switchMusic({name: XwaysHoarder2Sound.SFS_MUSIC});
            }
        } else {
            XwaysHoarder2Sound.switchMusic({name: XwaysHoarder2Sound.SFS_LEVEL_4_MUSIC});
        }
        XwaysHoarder2.backgroundElements.setBackground(XW2GameMode.BINGE_SPINS, XwaysHoarder2.model.data.mode, true);
        XwaysHoarder2.foregroundElements.setForeground(XW2GameMode.BINGE_SPINS, XwaysHoarder2.model.data.mode, true);
        XwaysHoarder2.transitionPlayer.playSpineIdleLoop(XW2GameMode.BINGE_SPINS);

    }

    public static restore() {
        const model = XwaysHoarder2.model;
        const reelData = model.initData.reels;

        if (model.data.mode === GameMode.RESPIN || model.data.nextMode === GameMode.RESPIN) {
            RestoreUtils.restoreLootSpins();
        } else if ((model.data.currentFSLevel === 4 || model.data.nextFSLevel === 4) && model.data.mode !== "NORMAL") {
            RestoreUtils.restoreBingeSpins();
        } else if (model.data.mode === GameMode.FREESPIN || (model.data.nextMode === GameMode.FREESPIN)) {
            RestoreUtils.restoreFreespins();
        } else if (model.data.mode === XW2GameMode.SUPER_FREESPIN || (model.data.nextMode === XW2GameMode.SUPER_FREESPIN)) {
            RestoreUtils.restoreSuperFreespins();
        }
        this.restoreLockedSymbols();

        XwaysHoarder2.keypadPlugin.setWin(XwaysHoarder2.model.initData.accumulatedRoundWin, true, XwaysHoarder2.isWinBelowStake());
        /*const reels = XwaysHoarder2.reelView.reelModels;
        for (let reel = 0; reel < 3; reel++) {
            for (let row = 0; row < 1; row++) {
                const symbol = Potslot.symbolFactory.createSymbol({symbolName: reelData[reel][row],
                                                                          reelID: reel,
                                                                          reelPosition: 0})
                reels[reel + row].insertSymbols([symbol]);
               // if (model.initData.winningSymbols.length > 0 && model.initData.winningSymbols[reel][row] == 1)
                    //BrickSnake2000.reelView.setMultiplierTo(model.data.splitSizes[reel][row] + 1, reel, row);
            }
        }
        XwaysHoarder2.reelView.extractSymbols();

        XwaysHoarder2.backgroundElements.restore(Potslot.model.initData.mode);*/
    }

    private static restoreLockedSymbols(): void {
        if (!XwaysHoarder2.model.isFreespinStarting && !XwaysHoarder2.model.isFreespinEnding && !XwaysHoarder2.model.isBaseGameRound && !XwaysHoarder2.model.isSuperFreespinStarting && !XwaysHoarder2.model.isSuperFreespinEnding && !XwaysHoarder2.model.isRespinEnding) {

            for (let reelId: number = 0; reelId < XwaysHoarder2.model.data.reelsAfterCollapse.length; reelId++) {
                if (reelId === 5) {
                    if (!XwaysHoarder2.model.isRespinStarting && !XwaysHoarder2.model.isRespinGameSpin) {
                        break;
                    }
                }

                [0, 1, 2].forEach((symNo: number) => {

                    if (XwaysHoarder2.model.data.reelsAfterCollapse[reelId][symNo] === "XS") {

                        const xsplitsym: XSplitSymbol = <XSplitSymbol>XwaysHoarder2.reelView.reels[reelId].model.getVisibleSymbolAt(symNo).positionable;
                        xsplitsym.getStateAnimation(SymbolStates.STICKY).timeScale(100);
                        XwaysHoarder2.reelView.reels[reelId].lockSpecialSymAndAddDummyBelow(symNo, "D", true);


                    }


                    if (XwaysHoarder2.model.data.reelsAfterCollapse[reelId][symNo] === "SC" || XwaysHoarder2.model.data.reelsAfterCollapse[reelId][symNo] === "SSC") {
                        if (XwaysHoarder2.model.data.nextMode === GameMode.RESPIN) {
                            const scatterSym: ScatterSymbol = <ScatterSymbol>XwaysHoarder2.reelView.reels[reelId].model.getVisibleSymbolAt(symNo).positionable;
                            (<ScatterSymbol>scatterSym).getStateAnimation(SymbolStates.STICKY).timeScale(100);
                            XwaysHoarder2.reelView.reels[reelId].lockSpecialSymAndAddDummyBelow(symNo, "D", true);

                        }
                    }

                });

            }
        }
        const myReels: string[][] = JSON.parse(JSON.stringify(XwaysHoarder2.model.data.reels));
        [1, 2, 3, 4].forEach((reelId) => {
            [0, 1, 2].forEach((symId: number) => {
                if (XwaysHoarder2.model.data.reelsAfterCollapse[reelId][symId] === "XW") {
                    XwaysHoarder2.reelView.reels[reelId].replaceSymOnReel(symId, "XW", true);
                    myReels[reelId][symId] = "XW";
                }
            });
        });

        if (!XwaysHoarder2.model.isBaseGameRound) {

            const condtionForStickyXW: boolean = (XwaysHoarder2.model.isBonusGameSpin || (XwaysHoarder2.model.isRespinGameSpin) || XwaysHoarder2.model.isRespinStarting) && !(XwaysHoarder2.model.isFreespinStarting || XwaysHoarder2.model.isSuperFreespinStarting);

            [1, 2, 3, 4].forEach((reelId) => {
                if (XwaysHoarder2.model.xwaysCountPerReel[reelId] > 0) {
                    if (XwaysHoarder2.model.xwaysCountPerReel[reelId] === 1) {
                        [0, 1, 2].forEach((symId: number) => {
                            if (myReels[reelId][symId] == "XW") {
                                const xwaysymData: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[reelId].model.getVisibleSymbolAt(symId);
                                if (condtionForStickyXW) {
                                    (<XWaySymbol>xwaysymData.positionable).getStateAnimation(SymbolStates.STICKY).timeScale(100);
                                    XwaysHoarder2.reelView.reels[reelId].lockSpecialSymAndAddDummyBelow(symId, "D", true);
                                }
                            }
                        })
                    } else if (XwaysHoarder2.model.xwaysCountPerReel[reelId] === 2) {
                        if (myReels[reelId][1] === "XW" && myReels[reelId][0] === "XW" && myReels[reelId][2] !== "XW") {
                            const xwaysymData: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[reelId].model.getVisibleSymbolAt(0);
                            (<XWaySymbol>xwaysymData.positionable).mergeEndAnimation(2);
                            if (condtionForStickyXW) {
                                (<XWaySymbol>xwaysymData.positionable).getStateAnimation(SymbolStates.STICKY).timeScale(100);
                                XwaysHoarder2.reelView.reels[reelId].lockSpecialSymAndAddDummyBelow(0, "D", true);
                            }
                            XwaysHoarder2.reelView.reels[reelId].replaceSymOnReel(1, "D");

                        } else if (myReels[reelId][1] === "XW" && myReels[reelId][2] === "XW" && myReels[reelId][0] !== "XW") {
                            const xwaysymData: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[reelId].model.getVisibleSymbolAt(1);
                            (<XWaySymbol>xwaysymData.positionable).mergeEndAnimation(2);
                            if (condtionForStickyXW) {
                                (<XWaySymbol>xwaysymData.positionable).getStateAnimation(SymbolStates.STICKY).timeScale(100);
                                XwaysHoarder2.reelView.reels[reelId].lockSpecialSymAndAddDummyBelow(1, "D", true);
                            }
                            XwaysHoarder2.reelView.reels[reelId].replaceSymOnReel(2, "D");

                        } else if (myReels[reelId][1] !== "XW" && myReels[reelId][2] === "XW" && myReels[reelId][0] === "XW") {
                            const xwaysymData: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[reelId].model.getVisibleSymbolAt(0);
                            if (condtionForStickyXW) {
                                (<XWaySymbol>xwaysymData.positionable).getStateAnimation(SymbolStates.STICKY).timeScale(100);
                                XwaysHoarder2.reelView.reels[reelId].lockSpecialSymAndAddDummyBelow(0, "D", true);


                            }
                            const xwaysymData2: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[reelId].model.getVisibleSymbolAt(2);
                            if (condtionForStickyXW) {
                                (<XWaySymbol>xwaysymData2.positionable).getStateAnimation(SymbolStates.STICKY).timeScale(100);
                                XwaysHoarder2.reelView.reels[reelId].lockSpecialSymAndAddDummyBelow(2, "D", true);


                            }

                        }
                    } else if (XwaysHoarder2.model.xwaysCountPerReel[reelId] == 3) {
                        const xwaysymData: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[reelId].model.getVisibleSymbolAt(0);
                        if (condtionForStickyXW) {
                            (<XWaySymbol>xwaysymData.positionable).mergeEndAnimation(3);
                            (<XWaySymbol>xwaysymData.positionable).getStateAnimation(SymbolStates.STICKY).timeScale(100);
                            XwaysHoarder2.reelView.reels[reelId].lockSpecialSymAndAddDummyBelow(0, "D", true);

                        }

                        XwaysHoarder2.reelView.reels[reelId].replaceSymOnReel(2, "D");
                        XwaysHoarder2.reelView.reels[reelId].replaceSymOnReel(1, "D");


                    }

                }
            });


        }
    }
}